import React from 'react';

const RequestForRoomBook = () => {
    return (
        <div>
            hiii
        </div>
    );
};

export default RequestForRoomBook;